import React from "react";
import { useWorkflowInput } from "ra-friendsofbabba";

const Input = ({ component, disabled, ...props }) => {
  const { visible, disabled: disable } = useWorkflowInput({ ...props });
  if (!visible) {
    return null;
  }
  return React.cloneElement(component, {
    ...component.props,
    ...props,
    disabled: disable === true || disabled === true,
  });
};
export default Input;
